// extracted by mini-css-extract-plugin
export var infoRow = "_rf-2";
export var labelContainer = "_rf-0";
export var rightInfo = "_rf-1";